module.exports = __webpack_public_path__ + "img/tacha.91c978ad.svg";